<div class="sidebar-object sm-nav">
  <div class="reportScrollSideMenu sm-nav__scroll">
    <ul class="list-recent reportsSidemenu sm-nav__list">
      @for (data of sideData; track data; let i = $index) {
        <li
          class="clearfix ripple side-menu-list-item sm-nav__item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="linkActiveOptions(data)"
        >
          <a
            class="sm-nav__link"
            routerLink="{{ data.route }}"
          >
            <span class="sideMenuIconBox sm-nav__icon">
              <i class="fa fa-{{ data.img }} side-menu-icon" aria-hidden="true"></i>
            </span>
            <span class="side-menu-text sm-nav__label">{{ data.name | translate }}</span>
          </a>
        </li>
      }
    </ul>
  </div>
</div>
